<template>
  <v-app-bar
    id="app-bar"
    app
    flat
    height="0"
    :color="$store.state.socio.cor"
    style="flex: none"
  >
    <v-spacer />
  </v-app-bar>
</template>

<style>
.TopLink {
  float: left;
  margin: 15px;
  font-family: "NeulisAlt-Regular";
  text-transform: uppercase;
  color: black !important;
  font-weight: bold;
}

.menuIconsCol {
  box-shadow: 0 0 0 1px black;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-app-bar {
  box-shadow: 0 0 0 1px black;
  background-color: transparent;
}

.menuIconsCol .v-btn {
  margin-bottom: 0px !important;
}
</style>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "InternalCoreAppBar",

  components: {},

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    notifications: [
      "Mike John Responded to your email",
      "You have 5 new tasks",
      "You're now friends with Andrew",
      "Another Notification",
      "Another one",
    ],
    profile: [
      { title: "Profile" },
      { title: "Settings" },
      { divider: true },
      { title: "Log out" },
    ],
  }),

  computed: {
    ...mapState(["drawer"]),
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
  },
};
</script>
